
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#816cc2","width":"12.332","height":"7.87"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.314.258a.777.777 0 00.077 1.073l2.2 1.839H.767a.767.767 0 000 1.533h8.824l-2.2 1.838a.779.779 0 00-.077 1.072.779.779 0 001.072.078l3.677-3.18a.711.711 0 000-1.113L8.386.181a.774.774 0 00-1.072.077z","fill":"inherit"}})])
          )
        }
      }
    